import { Customer } from 'server/shared/models/customer';
import { Employment } from 'server/shared/models/employment';
import { EmploymentInvitee } from 'server/shared/models/employmentInvitee';

/**
 * filtering invitees by access is necessary because the back-end keeps invitees of other customers that also work for the current customer on the employment.
 * They are kept, so that the client can filter out already invited users of the own pool when they were invited by another customer.
 */
export function canAccessEmploymentInvitee<T extends EmploymentInvitee>(
  invitee: T,
  currentCustomer: Customer,
  employment: Employment | undefined,
  sharedPoolCustomers: Customer[] | undefined,
): boolean {
  return !!(
    invitee.customer.id === currentCustomer._id ||
    currentCustomer._id === employment?.customer.id ||
    (employment?.ownerCustomerIds &&
      employment?.ownerCustomerIds.includes(currentCustomer._id)) ||
    sharedPoolCustomers?.find((c) => c._id === invitee.customer.id)
  );
}
